import { Box, alpha } from '@mui/material';

/** How far a dim overlay dims what it covers. */
export const DIM_OVERLAY_ALPHA = 0.16;

/** How long a dim overlay takes to come and go. */
export const DIM_OVERLAY_MS = 280;

/** Where a dim overlay sits among what it covers. */
export const DIM_OVERLAY_Z_INDEX = 2;

/** Where what stays clear of a dim overlay sits, such as a pinned card. */
export const ABOVE_DIM_OVERLAY_Z_INDEX = DIM_OVERLAY_Z_INDEX + 1;

export interface DimOverlayProps {
  isShown: boolean;
}

/**
 * DimOverlay gently dims what it covers, filling its positioned parent, such as
 * the bars while a pinned card is worked through. It never takes a tap.
 */
export const DimOverlay = ({ isShown }: DimOverlayProps) => (
  <Box
    aria-hidden
    sx={(theme) => ({
      position: 'absolute',
      inset: 0,
      zIndex: DIM_OVERLAY_Z_INDEX,
      pointerEvents: 'none',
      bgcolor: alpha(theme.palette.text.primary, DIM_OVERLAY_ALPHA),
      opacity: isShown ? 1 : 0,
      transition: `opacity ${DIM_OVERLAY_MS}ms ease-in-out`,
    })}
  />
);

DimOverlay.displayName = 'DimOverlay';
export default DimOverlay;
